import { useState, type Dispatch, type SetStateAction } from 'react'

import { Alert, Box } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'

import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import type { CustomTimeRangeCategoryFormType } from 'modules/time_categories_settings/lib/forms/CreateCustomTimeRangeCategoryForm'

import Footer from './Footer'

interface Props {
  setModalOpen: Dispatch<SetStateAction<boolean>>
  form: FormikProps<CustomTimeRangeCategoryFormType>
}

interface FormErrors {
  name: string
}

const CategoryModal = ({ setModalOpen, form }: Props) => {
  const { values: formValues, errors: formErrors } = form
  const [missingError, setMissingError] = useState({ name: false })

  const onChangeName = (value: string) => {
    setMissingError((prevState) => ({ ...prevState, name: false }))
    form.setFieldValue('name', value)
  }

  const validateForm = (formValues: CustomTimeRangeCategoryFormType) => {
    const errors: FormErrors = {
      name: !formValues.name ? i18n.t('work_time_categories.modals.errors.missing_name') : '',
    }
    return errors
  }

  const onSubmit = () => {
    form.setFieldValue('timeType', 'any_time', false)

    const errors = validateForm(form.values)
    const hasErrors = Object.values(errors).some(Boolean)

    if (!hasErrors) {
      form.handleSubmit()
    } else {
      setMissingError({ name: true })
    }
  }

  const errorNameMessage =
    formErrors.name ||
    (missingError.name && i18n.t('work_time_categories.modals.errors.missing_name')) ||
    ''

  const onClose = () => {
    form.resetForm()
    setMissingError({ name: false })
    setModalOpen(false)
  }

  return (
    <Modal
      title={i18n.t('work_time_categories.actions.edit')}
      illustration="document-edit"
      description={i18n.t('work_time_categories.modals.description')}
      onSubmit={onSubmit}
      onClose={onClose}
      footer={<Footer onClose={onClose} disabled={form.isSubmitting} />}
    >
      <TextField
        label={i18n.t('common.name')}
        error={errorNameMessage}
        mandatory
        value={formValues.name}
        onChange={onChangeName}
      />
      {formErrors.name && (
        <Box paddingTop="s24">
          <Alert color="error">
            {i18n.t('work_time_categories.modals.errors.duplicated_name')}
          </Alert>
        </Box>
      )}
    </Modal>
  )
}

export default CategoryModal
